/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { GridInterface } from './gridTypes';
import styles from './grid.module.scss';
import Card from '../../UI/card/cardComponent';

const Grid: React.FC<GridInterface> = ({
  listings,
  onClick,
  onEdit,
  onFavorite,
  isOwner,
  alreadyFavorite,
  favoriteVisable,
}) => {
  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 1200 }),
    isTabletOrMobile: useMediaQuery({ maxWidth: 1200, minWidth: 800 }),
    isMobile: useMediaQuery({ maxWidth: 800 }),
  };

  const getGrid = () => {
    if (resolution.DesktopOrLaptop) {
      return styles.threeColumns;
    }
    if (resolution.isTabletOrMobile) {
      return styles.twoColumns;
    }
    if (resolution.isMobile) {
      return styles.oneColumn;
    }

    return styles.oneColumn;
  };

  return (
    <div className={getGrid()}>
      {listings.map((l) => (
        <Card
          data={l}
          name={l.name}
          adress={l.city}
          price={l.price}
          photo={l.img1}
          onClick={onClick}
          onEdit={onEdit}
          onFavorite={onFavorite}
          isOwner={isOwner(l.owner)}
          alreadyFavorite={l.isFavorite}
          key={l.id}
          maxWidth={resolution.DesktopOrLaptop ? 424 : 550}
          favoriteVisible={favoriteVisable}
        />
      ))}
    </div>
  );
};

export default Grid;
